import {dateFromServer} from "@/functions/dates.ts";
import {GetPersonAlias, PatchWorkspaceCoachee} from "@/sdk.ts";

export class PersonAlias {
  first_name: string;
  last_name: string;
  readonly created_at: Date;
  updated_at: Date | null;

  constructor(props: GetPersonAlias) {
    this.first_name = props.first_name;
    this.last_name = props.last_name;
    this.created_at = dateFromServer(props.created_at);
    this.updated_at = props.updated_at ? dateFromServer(props.updated_at) : null;
  }

  update(props: GetPersonAlias) {
    if(props.first_name) this.first_name = props.first_name;
    if(props.last_name) this.last_name = props.last_name;
    if(props.updated_at) this.updated_at = dateFromServer(props.updated_at);
  }
}